import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {InvoicesPage} from '../../../invoices/invoices-page'

export const Route = createFileRoute('/_app/invoices/')({
    component: InvoicesRoute,
})

function InvoicesRoute() {
    return (
        <Container size="lg" py="xl">
            <InvoicesPage />
        </Container>
    )
}
